module.exports = __webpack_public_path__ + "img/permission_picture_new5_eng.675af3fd.png";